//? The commented code is to show the total of city per category or to blur all the score

import { useAuth } from "../../context/auth-context"

export default function CategoryRow({ category, citiesSelector, isEveryVarBlocked }) {
    const { user } = useAuth()
    
    const variableTextClass = user?.selectedCities?.length === 2 ? "withTwo" : user?.selectedCities?.length === 1 ? "withOne" : ""
    const isTextBlur = isEveryVarBlocked ? "teaserDataHide" : ""
    const catPointsFormatted = parseFloat(category.weight?.toFixed(1))?.toString()
    const catWeight = `${category.weight}%`
    
    return (
        <>
            <h5 className="greyText">{category.title}</h5>
            <h5 className="pointsWeight greyText">{catPointsFormatted}</h5>
            <h5 className="pointsWeight greyText">{catWeight}</h5>
            <div className="catCityScoresContainer d-none d-lg-flex">
                {user?.selectedCities?.slice(citiesSelector.min, citiesSelector.max).map(city => {
                    const cityTotal = user?.result?.filter(varResult => varResult.catRefId === category._id)
                                        ?.reduce((acc, curr) => {
                                            const cityPoints = curr.citiesResults.find(cityResult => cityResult.datamexico_municipality_id === city.datamexico_municipality_id)?.points

                                            return acc + cityPoints
                                        }, 0).toFixed(1)


                    return (
                        <h5 key={`catCityScore-${city.datamexico_municipality_id}`} 
                            className={`catCityScore variableText ${variableTextClass} ${isTextBlur}`}
                        >
                            {/* N/A */}
                            {cityTotal}
                        </h5>
                    )
                })}
            </div>
        </>
    )
}
